export { CONFIG } from "./config";

export const COUNTRY_CODE = '+880';

export const APP_CONFIGS = {
  CLIENT_NAME:'TVS Auto Bangladesh',
  VERSION_NUMBER:'1.8.0',
  REFERENCE_OPTIONAL: true,
  COUNTRY: 'Bangladesh',
  CURRENCY: '৳',
  INVOICE_ADDRESS: 'TVS AUTO BANGLADESH LTD 304 Industrial Area (3rd & 4th Floor) TejgaonI, Dhaka 1208 TEL: +880-2-8891600, +880-2-9831001-2 www.tvsabl.com',
  COUNTRY_CODE:'+880',
  VALID_PHONE_DIGITS:10,
  VALID_POSTAL_CODE:4
}

export const STATUS_COLOR_CODING = {
  'Inquiry':'#FFA24D',
  'Pending':'#FFA24D',
  'Review':'#FFA24D',
  'Approved':'#05C194',
  'Accepted':'#05C194',
  'Active':'#05C194',
  'Rejected':'#E15C5C',
  'Closed':'#D2D2D2',
  'Matured':'#D2D2D2',
  'Withdrawn':'#D2D2D2'
}

export const STATUS_LABEL = {
  'Inquiry':'Enquiry',
  'Pending':'Pending to submit',
  'Review':'Pending to review',
  'Approved':'Approved',
  'Accepted':'Accepted',
  'Active':'Active',
  'Rejected':'Rejected',
  'Closed':'Closed',
  'Withdrawn':'Withdrawn',
  'Matured':'Matured'
}

export const GENDER_OPTIONS = [
  { label: "Male", value: "M" },
  { label: "Female", value: "F" },
];

export const DISCOUNT_TYPE = [
  {label: "No Discount", value:"NIL"},
  {label: "Flat", value:"FLAT"},
  {label: "Percentage", value:"PERCENTAGE"}
]

export const SALUTATION_OPTIONS = [
  { label: "Mr.", value: "Mr." },
  { label: "Ms.", value: "Ms." },
  { label: "Mrs.", value: "Mrs." },
  { label: "Dr.", value: "Dr." },
  { label: "Prof.", value: "Prof." },
];

export const RESIDENTIAL_OPTIONS = [
  { label: "Rent", value: "Rent" },
  { label: "Shared Rent", value: "Shared Rent" },
  { label: "Lease", value: "Lease" },
  { label: "Owned", value: "Owned" },
  { label: "Shared Ownership", value: "Shared Ownership" },
  { label: "Parental Property", value: "Parental Property" },
  { label: "N/A", value: "N/A" },
];

export const YEARS_CURRENT_ADDRESS_OPTIONS = [
  { label: "<3 months", value: "<3 months" },
  { label: "3-12 months", value: "3-12 months" },
  { label: "1-2 years", value: "1-2 years" },
  { label: "2-3 years", value: "2-3 years" },
  { label: "3-4 years", value: "3-4 years" },
  { label: "4-5 years", value: "4-5 years" },
  { label: "5+ years", value: "5+ years" },
];
export const YEARS_CURRENT_WORK_OPTIONS = [
  { label: "0 month", value: "0 month" },
  { label: "0-2 months", value: "0-2 months" },
  { label: "3-6 months", value: "3-6 months" },
  { label: "6-11 months", value: "6-11 months" },
  { label: "12-17 months", value: "12-17 months" },
  { label: "18-23 months", value: "18-23 months" },
  { label: "2-3 years", value: "2-3 years" },
  { label: "3+ years", value: "3+ years" },
];
export const YEARS_TOTAL_WORK_OPTIONS = [
  { label: "<1 Year", value: "<1 Year" },
  { label: "1-2 Years", value: "1-2 Years" },
  { label: "3-4 Years", value: "3-4 Years" },
  { label: "5-6 Years", value: "5-6 Years" },
  { label: "7-10 Years", value: "7-10 Years" },
  { label: "10-15 Years", value: "10-15 Years" },
  { label: "15 Years +", value: "15 Years +" },
];
export const MARITAL_STATUS_OPTIONS = [
  { label: "Single", value: "Single" },
  { label: "Married", value: "Married" },
  { label: "Separated", value: "Separated" },
  { label: "Divorced", value: "Divorced" },
  { label: "Widowed", value: "Widowed" },
];

export const DEPENDENT_OPTIONS = [
  { label: "0", value: "0" },
  { label: "1", value: "1" },
  { label: "2", value: "2" },
  { label: "3+", value: "3" },
];

export const NO_OF_LOANS_OPTIONS = [
  { label: "0", value: "0" },
  { label: "1", value: "1" },
  { label: "2", value: "2" },
  { label: "3", value: "3" },
  { label: "3+", value: "3+" },
];

export const LOAN_MONTH_OPTIONS = [
  { label: "1 month", value: 1 },
  { label: "2 months", value: 2 },
  { label: "3 months", value: 3 },
  { label: "4 months", value: 4 },
  { label: "5 months", value: 5 },
  { label: "6 months", value: 6 },
  { label: "7 months", value: 7 },
  { label: "8 months", value: 8 },
  { label: "9 months", value: 9 },
  { label: "10 months", value: 10 },
  { label: "11 months", value: 11 },
  { label: "12 months", value: 12 },
];

export const BANK_OPTIONS = [
  { label: "AB Bank", value: "1" },
  { label: "Al-Arafah Islami Bank", value: "2" },
  { label: "Bangladesh Commerce Bank", value: "3" },
  { label: "Bank Asia", value: "4" },
  { label: "BRAC Bank", value: "5" },
  { label: "City Bank", value: "6" },
  { label: "Commercial Bank", value: "7" },
  { label: "Dhaka Bank", value: "8" },
  { label: "Dutch Bangla Bank", value: "9" },
  { label: "Eastern Bank", value: "10" },
  { label: "Grameen Bank", value: "11" },
  { label: "HSBC", value: "12" },
  { label: "IFIC bank", value: "13" },
  { label: "Jamuna Bank", value: "14" },
  { label: "Janata Bank", value: "15" },
  { label: "Lanka Bangla Bank", value: "16" },
  { label: "Meghna Bank", value: "17" },
  { label: "Mercantile Bank", value: "18" },
  { label: "Midland Bank", value: "19" },
  { label: "Modhumoti Bank", value: "20" },
  { label: "Mutual Trust Bank", value: "21" },
  { label: "National Bank", value: "22" },
  { label: "NCC Bank", value: "23" },
  { label: "NRB Bank", value: "24" },
  { label: "NRBC Bank", value: "25" },
  { label: "One Bank", value: "26" },
  { label: "Padma Bank (Farmers Bank)", value: "27" },
  { label: "Premier Bank", value: "28" },
  { label: "Prime Bank Limited", value: "29" },
  { label: "Pubali Bank", value: "30" },
  { label: "SBAC Bank", value: "31" },
  { label: "Shahjalal Islami Bank", value: "32" },
  { label: "SIBL", value: "33" },
  { label: "Simanto Bank", value: "34" },
  { label: "Sonali Bank", value: "35" },
  { label: "South Bangla Commerce Bank", value: "36" },
  { label: "Southeast Bank", value: "37" },
  { label: "Standard Bank", value: "38" },
  { label: "Standard Chartered", value: "39" },
  { label: "Trust Bank", value: "40" },
  { label: "UCB", value: "41" },
  { label: "United Commercial Bank", value: "42" },
  { label: "Uttara Bank", value: "43" },
];

export const REPAYMENT_METHOD_OPTIONS = [
  { label: "Cash", value: "1" },
  { label: "Cheque", value: "2" },
  { label: "Credit Card", value: "3" },
  { label: "Debit Card", value: "4" },
  { label: "Bank - EFT", value: "5" },
  { label: "Online Pay (Bkash)", value: "6" },
  { label: "Online Pay (Other)", value: "7" },
  { label: "Nagad (Collection Agent)", value: "8" },
  { label: "Other", value: "9" },
];

export const INCOME_PROOF_OPTIONS = [
  { label: "Latest TIN certification (e-TIN)", value: "1" },
  { label: "1 Year personal bank statement", value: "2" },
  { label: "Personal net worth statement", value: "3" },
  {
    label:
      "Salary of certification / Letter of introduction (by company admin)",
    value: "4",
  },
  { label: "3 Month payslip (physical or bank statement)", value: "5" },
  { label: "Company Bank Statement for at least 1-3 year", value: "6" },
  { label: "Monthly Sales report", value: "7" },
  { label: "Undertaking of client duly signed", value: "8" },
  { label: "Self Declaration of earnings", value: "9" },
];

export const RELATIONSHIP_OPTIONS = [
  { label: "Parent / Parent in Law", value: "1" },
  { label: "Sibling", value: "2" },
  { label: "Child / Grandchild", value: "3" },
  { label: "Grandparent", value: "4" },
  { label: "Spouse / Partner", value: "5" },
  { label: "Broker", value: "6" },
  { label: "Friend", value: "7" },
  { label: "Neighbour", value: "8" },
  { label: "Colleague", value: "9"},
  { label: "Other", value: "10" },
  
];

export const ADDRESS_PROOF_OPTIONS = [
  {
    label: "Latest Utility bill (gas, water, electricity, municipal tax)",
    value: "1",
  },
  { label: "Rent or lease agreement", value: "2" },
  { label: "Bank Statement", value: "3" },
  { label: "Self Declaration", value: "4" },
];

export const ID_TYPE_OPTIONS = [{ label: "National ID", value: "1" }];

export const ID_PROOf_OPTIONS = [
{ label: "Self Photo", value: "1" },
{ label: "NID Front", value: "2" },
{ label: "NID Back", value: "3" }];

export const DISTRICT_OPTIONS = [
  { label: "Bagerhat", value: "Bagerhat" },
  { label: "Dhaka", value: "Dhaka" },
];

export const COLOR_OPTIONS = [
  { label: "Blue", value: "Blue" },
  { label: "Green", value: "Green" },
];

export const MODEL_OPTIONS = [
  { label: "TVS Apache RTR 160 2V", value: "TVS Apache RTR 160 2V" },
  { label: "Metro 100CC", value: "Metro 100CC" },
];

export const TYPE_OPTIONS = [
  { label: "NIL", value: "NIL" },
  { label: "Comprehensive/First Class", value: "Comprehensive/First Class" },
  {
    label: "Co-passenger protection coverage",
    value: "Co-passenger protection coverage",
  },
  {
    label: "Third Party liability insurance",
    value: "Third Party liability insurance",
  },
  { label: "Personal Risk Coverage", value: "Personal Risk Coverage" },
];

export const CITY_OPTIONS = [
  { label: "Dhaka", value: "Dhaka" },
  { label: "Chattogram", value: "Chattogram" },
];

export const SORT_TYPES = [
  { label: "createUsers_role", value: "role" },
  { label: "review_sort_name", value: "name" },
];

export const USER_MODES = [
  { label: "createUsers_activeuser", value: "active" },
  { label: "createUsers_pendingusers", value: "pending" },
];

export const EMI_OPTIONS = [
  { label: "Flat", value: "flat" },
  { label: "Reducing", value: "reducing" },
];

export const YEARS_OPTIONS = [
  { label: "1 year", value: 1 },
  { label: "2 years", value: 2 },
  { label: "3 years", value: 3 },
  { label: "4 years", value: 4 },
  { label: "5 years", value: 5 },
  { label: "6 years", value: 6 },
  { label: "7 years", value: 7 },
  { label: "8 years", value: 8 },
  { label: "9 years", value: 9 },
  { label: "10 years", value: 10 },
  { label: "11 years", value: 11 },
  { label: "12 years", value: 12 },
];


export const DOCUMENT_CATEGORY_OPTIONS = [
  { label: "ID Proof", value: "ID Proof" },
  { label: "Income Proof", value: "Income Proof" },
  { label: "Address Proof", value: "Address Proof" }
  
];

export const INTEREST_STATUS = [
  { label: "Hot", value: "Hot" },
  { label: "Warm", value: "Warm" },
  { label: "Cold", value: "Cold" }
];

//Work Experience Bin
export const TOTAL_WORK_EXPERIENCE = [
{
  "<1 Year":1,
  "1-2 Years":2,
  "3-4 Years":4,
  "5-6 Years":6,
  "7-10 Years":10,
  "10–15 Years":15,
  "15 Years +":16
}]

export const CURRENT_WORK_EXPERIENCE = [{
  "0 month":1,
  "0-2 months":1,
  "3-6 months":2,
  "6-11 months":3,
  "12-17 months":4,
  "18-23 months":5,
  "2-3 years":6,
  "3+ years":7
}]

//Years at residence Bin
export const YEARS_AT_CURRENT_RESIDENCE = [{
  "<3 months":1,
  "3-12 months":2,
  "1-2 years":3,
  "2-3 years":4,
  "3-4 year":5,
  "4-5 years":6,
  "5+ years":7
}]

//Employment type Mappping

export const EMPLOYMENT_TYPE = [{
  'SALARIED (GOVERNMENT)':'SALARIED',
  'SALARIED (NON-GOVERNMENT)':'SALARIED-NG',
  'SELF EMPLOYED':'SELF_EMPLOYED',
  'AGRICULTURE':'AGRICULTURE',
  'HOUSEWIFE':'HOUSEWIFE',
  'RETIRED':'RETIRED',
  'PENSIONER':'PENSIONER',
  'OTHERS':'OTHERS'
}]